import { useEffect } from "react";
import { Link } from "react-router-dom";
import { m as motion } from "framer-motion";
import { X, ChevronDown, Phone } from "lucide-react";
import { NAV } from "@/data/nav";
import { SITE } from "@/data/site";
import { getLenis } from "@/lib/lenis";

const subLinks = (item) => [...(item.items || []), ...(item.audiences || []), { label: `All ${item.label}`, href: item.href }];

export const MobileMenu = ({ onClose }) => {
  useEffect(() => {
    getLenis()?.stop();
    document.body.style.overflow = "hidden";
    return () => {
      getLenis()?.start();
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 40 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-0 z-[70] flex flex-col bg-white"
      data-lenis-prevent
      data-testid="mobile-menu"
    >
      <div className="flex h-[72px] items-center justify-between border-b border-[#eee] px-5">
        <img src="/img/logo-360.webp" alt="Wholesale LVP Flooring" width="360" height="68" className="h-7 w-auto" />
        <button type="button" onClick={onClose} aria-label="Close menu" className="grid h-11 w-11 place-items-center rounded-full bg-[#111] text-white" data-testid="mobile-menu-close">
          <X className="h-5 w-5" />
        </button>
      </div>
      <nav aria-label="Mobile" className="flex-1 overflow-y-auto px-5 py-4">
        <ul className="divide-y divide-[#eee]">
          <li><Link to="/" className="block py-4 text-xl font-extrabold" data-testid="mobile-nav-home">Home</Link></li>
          {NAV.map((item) =>
            item.mega ? (
              <li key={item.label}>
                <details className="group">
                  <summary className="flex cursor-pointer list-none items-center justify-between py-4 text-xl font-extrabold" data-testid={`mobile-nav-group-${item.mega}`}>
                    {item.label}
                    <ChevronDown className="h-5 w-5 transition-transform group-open:rotate-180" />
                  </summary>
                  <ul className="grid gap-1 pb-4">
                    {subLinks(item).map((s) => (
                      <li key={s.href}>
                        <Link to={s.href} className="block rounded-lg bg-[#f6f4ef] px-4 py-3 font-semibold" data-testid={`mobile-nav-${s.href.split("/").pop() || "home"}`}>{s.label}</Link>
                      </li>
                    ))}
                  </ul>
                </details>
              </li>
            ) : (
              <li key={item.label}>
                <Link to={item.href} className="block py-4 text-xl font-extrabold" data-testid={`mobile-nav-${item.href.slice(1)}`}>{item.label}</Link>
              </li>
            )
          )}
        </ul>
      </nav>
      <div className="grid gap-3 border-t border-[#eee] p-5">
        <Link to="/free-estimate" className="btn btn-yellow btn-lg" data-testid="mobile-menu-estimate-btn">Get a Free Estimate</Link>
        <div className="grid grid-cols-2 gap-3">
          <Link to="/contractor-pricing" className="btn btn-outline" data-testid="mobile-menu-contractor-btn">Contractor Pricing</Link>
          <a href={`tel:${SITE.tel}`} className="btn btn-ink" data-testid="mobile-menu-call-btn"><Phone className="h-4 w-4" /> Call</a>
        </div>
      </div>
    </motion.div>
  );
};
